import React from "react";
import { I18nextProvider } from "react-i18next";
import { Redirect, Route } from "react-router-dom";
import { APP_LANGUAGE, ROUTER_PATH } from "../common/constant";
import i18n from "../i18n";
import {
  clearVoucherInfo,
  getVoucherInfo,
  setVoucherInfo,
} from "../utils/helpers";
import { vouchers } from "../services";
import { IVoucherInfo } from "../models/interface/IVoucherInfo";

interface Props {
  RouterComponent: React.ComponentClass<any>;
  defaultLanguage?: any;
  children: any;
}

const LocalizedRouter = (props: Props) => {
  const { children, defaultLanguage, RouterComponent } = props;

  const getVoucher = async (search: string, lang: string) => {
    const voucherCode = new URLSearchParams(search).get("voucher") || "";
    const voucher: any = await vouchers.getVoucherDetail(voucherCode);

    if (!voucher) {
      clearVoucherInfo();
    } else {
      setVoucherInfo(voucher);
    }

    window.location.href = `/${lang}/`;
  };

  const cleanVoucher = (search: string) => {
    const hasCleanVoucher = new URLSearchParams(search).get("cleanvoucher") || false;
    if (hasCleanVoucher) {
      clearVoucherInfo();
    }
  }

  const validateVoucher = async () => {
    const voucherInfo: IVoucherInfo = getVoucherInfo();
    if (!voucherInfo || !voucherInfo.code) return;

    const voucher = await vouchers.getVoucherDetail(voucherInfo.code);

    if (!voucher) {
      clearVoucherInfo();
    }
  };

  return (
    <RouterComponent>
      <Route path="/:lang([a-zA-z]{2})">
        {({ match, location }) => {
          const { pathname, search } = location;
          const params: any = match ? match.params : {};

          const { lang = defaultLanguage || APP_LANGUAGE.Vietnamese } = params;

          if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
          }

          validateVoucher();

          //Case: order short link
          if (
            !pathname.toLowerCase().includes(`/${lang}/`) &&
            pathname.toLowerCase().includes(`/o/`)
          ) {
            const _pathName = pathname.replace(
              "/o/",
              `${i18n.t(ROUTER_PATH.ORDERS)}/`
            );
            return <Redirect to={`/${lang}${_pathName}`} />;
          }

          //Case: voucher code
          if (
            pathname.toLowerCase() === "/" &&
            search.toLowerCase().includes(`?voucher=`)
          ) {
            getVoucher(search, lang);
            return;
          }

          if (search?.toLowerCase?.()?.includes("cleanvoucher=")) {
            cleanVoucher(search.toLowerCase())
          }

          if (!pathname.toLowerCase().includes(`/${lang}/`)) {
            return <Redirect to={`/${lang}/`} />;
          }

          return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
        }}
        {/* {children}; */}
      </Route>
    </RouterComponent>
  );
};

export default LocalizedRouter;
